import { Component } from "react";

class HubspotBrochureDownload extends Component {
    constructor(props) {
        super(props);
        this.state = {
          loading: true,
        };
    }
    // componentDidMount(props) {
    //     const script = document.createElement("script");
    //     script.src = "https://js.hsforms.net/forms/v2.js";
    //     document.body.appendChild(script);

    //     script.addEventListener("load", () => {
    //     if (window.hbspt) {
    //         window.hbspt.forms.create({
    //         portalId: "6153052",
    //         formId: `${this.props.formID}`,
    //         target: "#hubspotForm"
    //         });
    //     }
    //     });
    // }
    componentDidMount() {
        const script = document.createElement("script");
        script.src = "https://js.hsforms.net/forms/v2.js";
        document.body.appendChild(script);

        script.addEventListener("load", () => {
          if (window.hbspt) {
            window.hbspt.forms.create({
              portalId: "6153052",
              formId: this.props.formID,
              target: "#hubspotForm",
              onFormReady: () => {
                this.setState({ loading: false });
              }
            });
          }
        });
    }

    render() {
        return (
            <div>
                {this.state.loading && (
                <div className="hubspot-loader">
                    {/* Replace with your custom loader/spinner */}
                    <p className="text-white">Loading form...</p>
                </div>
                )}
                <div id="hubspotForm" />
            </div>
        );
    }
}

export default HubspotBrochureDownload;
